import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {ErrorNotificationComponent} from './error-notification.component';
import {SimpleNotificationComponent} from './simple-notification.component';
import {ToastModule} from 'primeng/toast';
import {FormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';

@NgModule({
    declarations: [
        ErrorNotificationComponent,
        SimpleNotificationComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ToastModule,
        ButtonModule
    ],
    exports: [
        ErrorNotificationComponent,
        SimpleNotificationComponent
    ]
})
export class NotificationModule { }
